const deformatPhoneNumber = (formattedPhone: string): string => {
  return ("" + formattedPhone).replace(/\D/g, "")
}

interface FormatOptions {
  countryCode?: string
}

const formatPhoneNumber = (phoneNumberString: string, options?: FormatOptions): string => {
  if (!phoneNumberString || phoneNumberString.length < 3) {
    return ""
  }

  let input = deformatPhoneNumber(phoneNumberString)
  const size = input.length

  if (input.length < 3) {
    return ""
  }

  if (options?.countryCode) {
    const countryCode = deformatPhoneNumber(options.countryCode)

    if (size === 10) {
      return `+${countryCode} (${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6, 10)}`
    } else if (size > 6) {
      return `+${countryCode} (${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6, size)}`
    } else if (size > 3) {
      return `+${countryCode} (${input.substring(0, 3)}) ${input.substring(3, size)}`
    } else if (size > 0) {
      return `+${countryCode} (${input}`
    } else {
      return `+${countryCode}`
    }
  }

  if (input.startsWith("00") && size > 10) {
    input = input.substring(2)
  }

  if (size > 10) {
    const countryCode = input.substring(0, input.length - 10)
    const mainNumber = input.substring(input.length - 10)
    return `+${countryCode} (${mainNumber.substring(0, 3)}) ${mainNumber.substring(
      3,
      6,
    )}-${mainNumber.substring(6, 10)}`
  } else if (size === 10) {
    return `(${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6, 10)}`
  } else if (size > 6) {
    return `(${input.substring(0, 3)}) ${input.substring(3, 6)}-${input.substring(6, size)}`
  } else if (size > 3) {
    return `(${input.substring(0, 3)}) ${input.substring(3, size)}`
  } else if (size > 0) {
    return `(${input}`
  } else {
    return ""
  }
}

export { formatPhoneNumber, deformatPhoneNumber }
